import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, Event as RouterEvent, NavigationStart, NavigationEnd } from '@angular/router'; // , RouteConfigLoadEnd, RouteConfigLoadStart

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';

import { SocketService } from './services/socket.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { PushService } from './services/push.service';
import { ToasterService } from './services/toaster.service';
import { SettingService } from './services/setting.service';
import { ChatService } from './services/chat.service';
import { EventService } from './services/event.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
    private ngUnsubscribe = new Subject();
    isShowingRouteLoadIndicator: boolean;
    connection = new Array(); // for socket connection
    settings: any;
    constructor(
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        private iconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer,
        private settingService: SettingService,
        private socketService: SocketService,
        private toasterService: ToasterService,
        private eventService: EventService,
        private chatService: ChatService,
        private pushSvc: PushService,
        private router: Router
    ) {

        this.socketService.init('//io.chanceball.com');
        // this.socketService.init('http://io.chanceball.com:3001');

        this.socketService.Emit('add_page', {page: '@index'});

        this.isShowingRouteLoadIndicator = false;

        // As the router loads modules asynchronously (via loadChildren), we're going to
        // keep track of how many asynchronous requests are currently active. If there is
        // at least one pending load request, we'll show the indicator.
        // let asyncLoadCount = 0;

        // The Router emits special events for "loadChildren" configuration loading. We
        // just need to listen for the Start and End events in order to determine if we
        // have any pending configuration requests.
        this.router.events.subscribe(
            ( event: RouterEvent ): void => {
                if ( event instanceof NavigationStart ) {

                    this.isShowingRouteLoadIndicator = true;

                } else if ( event instanceof NavigationEnd ) {

                    this.isShowingRouteLoadIndicator = false;

                }

                // If there is at least one pending asynchronous config load request,
                // then let's show the loading indicator.
                // --
                // CAUTION: I'm using CSS to include a small delay such that this loading
                // indicator won't be seen by people with sufficiently fast connections.
            //     this.isShowingRouteLoadIndicator = !! asyncLoadCount;

            }
        );
    }

    ngOnInit() {
        this.settingService.getSetting((obj) => {
            this.settings = obj;
            this.initializeApp();
            this.setIconRegistry();
            this.listenGameResult();
        });
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    private initializeApp() {
        this.platform.ready().then(() => {
            if (this.platform.is('cordova')) {
            //    this.pushSvc.init();
                if (this.settings.all !== 'off') {
                    // push 토큰 등록
                    this.pushSvc.setTokenToServer();
                }


            }
            this.statusBar.styleDefault();
            this.splashScreen.hide();
        });
    }

    private setIconRegistry() {
        this.iconRegistry
            .addSvgIcon('close', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/close.svg')) // 닫기
            .addSvgIcon('add', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_add_24px.svg')) // 추가
            .addSvgIcon('reload', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/reload.svg')) // 새로고침
            .addSvgIcon('dot', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/6pt-dot.svg'))
            .addSvgIcon('home', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_home_24px.svg')) // 유저홈
            .addSvgIcon('message', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_message_24px.svg')) // 찬스톡
            .addSvgIcon('comment', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_comment_24px.svg')) // 쪽지보내기
            .addSvgIcon('supervisor', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_supervisor_account_24px.svg')) // 친구추가
            .addSvgIcon('thumb_down', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_thumb_down_24px.svg')) // 신고
            .addSvgIcon('mail', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_mail_outline_24px.svg')) // 편지봉투
            .addSvgIcon('remove', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_remove_circle_outline_24px.svg'))
            .addSvgIcon('delete', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_delete_24px.svg'))
            .addSvgIcon('room', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_room_24px.svg'))
            .addSvgIcon('edit', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_mode_edit_24px.svg'))
            .addSvgIcon('reply', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_reply_24px.svg'))
            .addSvgIcon('toinbox', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_move_to_inbox_24px.svg'))
            .addSvgIcon('done', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_done_24px.svg'))
            .addSvgIcon('check-circle', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_check_circle_24px.svg'))
            .addSvgIcon('keyboard-arrow-left', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_keyboard_arrow_left_24px.svg'))
            .addSvgIcon('keyboard-arrow-right', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ic_keyboard_arrow_right_24px.svg'))

            .addSvgIcon('xi-airplay', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-airplay.svg'))
            .addSvgIcon('xi-angle-left', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-angle-left.svg'))
            .addSvgIcon('xi-angle-left-thin', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-angle-left-thin.svg'))
            .addSvgIcon('xi-angle-right-min', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-angle-right-min.svg'))
            .addSvgIcon('xi-angle-right-thin', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-angle-right-thin.svg'))
            .addSvgIcon('xi-angle-up-min', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-angle-up-min.svg'))
            .addSvgIcon('xi-caret-down-min', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-caret-down-min.svg'))
            .addSvgIcon('xi-caret-up-min', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-caret-up-min.svg'))
            .addSvgIcon('xi-check-circle-o', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-check-circle-o.svg'))
            .addSvgIcon('xi-close', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-close.svg'))
            .addSvgIcon('xi-close-circle-o', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-close-circle-o.svg'))
            .addSvgIcon('xi-cog', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-cog.svg'))
            .addSvgIcon('xi-comment-o', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-comment-o.svg'))
            .addSvgIcon('xi-dollar', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-dollar.svg'))
            .addSvgIcon('xi-ellipsis-h', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-ellipsis-h.svg'))
            .addSvgIcon('xi-eye-o', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-eye-o.svg'))
            .addSvgIcon('xi-focus-weak', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-focus-weak.svg'))
            .addSvgIcon('xi-heart', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-heart.svg'))
            .addSvgIcon('xi-heart-o', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-heart-o.svg'))
            .addSvgIcon('xi-home-o', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-home-o.svg'))
            .addSvgIcon('xi-info-o', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-info-o.svg'))
            .addSvgIcon('xi-minus', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-minus.svg'))
            .addSvgIcon('xi-minus-circle-o', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-minus-circle-o.svg'))
            .addSvgIcon('xi-new', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-new.svg'))
            .addSvgIcon('xi-note-o', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-note-o.svg'))
            .addSvgIcon('xi-piggy-bank', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-piggy-bank.svg'))
            .addSvgIcon('xi-plus', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-plus.svg'))
            .addSvgIcon('xi-plus-circle-o', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-plus-circle-o.svg'))
            .addSvgIcon('xi-presentation', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-presentation.svg'))
            .addSvgIcon('xi-radiobox-blank', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-radiobox-blank.svg'))
            .addSvgIcon('xi-refresh', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-refresh.svg'))
            .addSvgIcon('xi-star-o', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-star-o.svg'))
            .addSvgIcon('xi-thumbs-down', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-thumbs-down.svg'))
            .addSvgIcon('xi-user-o', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-user-o.svg'))
            .addSvgIcon('xi-users-o', this.sanitizer.bypassSecurityTrustResourceUrl('assets/svg/xi-users-o.svg'))
            ;
    }


    /**
     * 게임결과를 수신하고 있다가 게임결과에 대한 팝업을 처리한다.
     * 이벤트를 생성하여 실시간 게임에 결과값을 전달한다.
     */
    private listenGameResult(): void {
        this.socketService.Emit('add_page', {page: '@index'});

        this.socketService.On('popOverMessage')
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(obj => {
            if (typeof this.settings === 'undefined') {
                return;
            }
            const req: any = obj[0];
            switch (req.msgType) {
                case 'pickResult':
                    const eventObj = {type: 'pickResult', data: req};
                    switch (req.detail.pick) {
                        case 'ladder':
                            this.eventService.broadcast('pickResult', eventObj); // 중계화면도 이 부분을 이용함
                            if (this.settings.ladderResult === false) { return; }
                            this.toasterService.showToaster('info', req.msg);
                            break;
                        case 'dari':
                            this.eventService.broadcast('pickResult', eventObj);
                            if (this.settings.dariResult === false) { return; }
                            this.toasterService.showToaster('info', req.msg);
                            break;
                        case 'powerball':
                            this.eventService.broadcast('pickResult', eventObj);
                            if (this.settings.powerballResult === false) { return; }
                            this.toasterService.showToaster('info', req.msg);
                            break;
                    }
                    break;
                case 'pickegis':
                    this.toasterService.showToaster('info', req.msg);
                    break;
                case 'feed':
                    if (this.settings.newfollower === false) { return; }
                    this.toasterService.showToaster('info', req.mb_nick + '님께서 회원님을 구독하였습니다.');
                    break;
                case 'chancetalk':
                    if (this.chatService.getCurrentChatRoomId() !== req.room_id) {
                        this.toasterService.showToaster('info', '찬스톡에 새로운 메시지가 도착하였습니다.');
                    }
                    break;
                case 'patternmatch':
                    if (this.settings.pattern === false) { return; }
                    this.toasterService.showToaster('info', '등록하신 패턴[' + req.item.title + ']이 매칭되었습니다.');
                    break;
            }
        });
    }

    // popover display 현황 처리
    popoverDisplay(e: any) {
        console.log(e);
    }
}
